import { ChangeEvent, useMemo, useState } from "react";
import { TextField, styled } from "@mui/material";
import { debounce } from "lodash-es";
import { useTranslation } from "react-i18next";

interface Props {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export function LayerManagerSearch(props: Props) {
  const { t } = useTranslation();
  const { searchValue, setSearchValue } = props;
  const [value, setValue] = useState(searchValue);

  const debouncedSetSearchValue = useMemo(() => debounce(setSearchValue, 300), [setSearchValue]);

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value;
    setValue(newValue);
    debouncedSetSearchValue(newValue);
  }

  return (
    <Styles>
      <TextField size="small" fullWidth placeholder={t("label.searchByLayerName")} value={value} onChange={onChange} />
    </Styles>
  );
}

const Styles = styled("div")`
  position: sticky;
  top: 59px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(1)};
  z-index: 10;
  .MuiInputBase-root {
    margin: 0;
  }
`;
